document.addEventListener('DOMContentLoaded', function () {
  //burgerMenu

  document
    .querySelector('.header__right-burger')
    .addEventListener('click', () => {
      const burgerMenu = document.querySelector('.header__burger-menu');
      const burgerImg = document.querySelector('#burgerImgOpenClose');
      const body = document.querySelector('body');
      burgerMenu.classList.toggle('open');
      if (burgerMenu.classList.contains('open')) {
        body.classList.add('scrollLockMob');
        const close = burgerImg.getAttribute('data-close');
        burgerImg.setAttribute('src', close);
      } else {
        body.classList.remove('scrollLockMob');
        const burger = burgerImg.getAttribute('data-burger');
        burgerImg.setAttribute('src', burger);
      }
    });

  //burger nav hide menu
  const navLinkBurger = document.querySelectorAll(
    '.header__burger-menu-top-nav-link'
  );

  navLinkBurger.forEach((e) => {
    e.addEventListener('click', () => {
      document.querySelector('.header__burger-menu').classList.remove('open');
      body.classList.remove('scrollLockMob');
      const btn = document.querySelector('#burgerImgOpenClose');
      const burger = btn.getAttribute('data-burger');
      btn.setAttribute('src', burger);
    });
  });

  //navigation

  const navigationLinks = document.querySelectorAll('.header__nav-menu-item');
  const blocks = document.querySelectorAll('.navElement');
  const navItems = document.querySelectorAll('.menu-item');

  navItems.forEach((e) => {
    e.addEventListener('click', () => {
      setTimeout(() => {
        header.classList.add('hide');
      }, 100);
    });
  });

  function activateLink(index) {
    for (let i = 0; i < navigationLinks.length; i++) {
      navigationLinks[i].classList.remove('active');
    }

    navigationLinks[index].classList.add('active');
  }

  function getActiveBlockIndex() {
    for (let i = 0; i < blocks.length; i++) {
      const rect = blocks[i].getBoundingClientRect();

      if (rect.top >= 0 && rect.top <= window.innerHeight) {
        return i;
      }
    }
    return -1;
  }

  function handleScroll() {
    const activeIndex = getActiveBlockIndex();

    if (activeIndex !== -1) {
      activateLink(activeIndex);
    }
  }

  //animRepeat

  const leftAnim = document.querySelector('#anim1');
  const rightAnim = document.querySelector('#anim2');
  const animImg = leftAnim.getAttribute('data-anim1');
  const animImg2 = rightAnim.getAttribute('data-anim2');

  setInterval(() => {
    leftAnim.setAttribute('data', animImg);
  }, 19000);

  setInterval(() => {
    rightAnim.setAttribute('data', animImg2);
  }, 15000);

  //modal modalForm

  const modal = document.querySelector('#myModal');
  const body = document.querySelector('body');
  const header = document.querySelector('.header');
  const formTitle = document.querySelector('.myModal__form-title');
  const formTitleColor = document.querySelector('.myModal__form-title-color');
  const socialFixed = document.querySelector('.header__social-fixed');
  const formCalc = document.querySelector('.myModal__form-calc');
  const formCar = document.querySelector('.myModal__form-car');
  const submitsAll = document.querySelectorAll('[data-thanks');

  document.querySelectorAll('[data-modals-open]').forEach((e) =>
    e.addEventListener('click', (e) => {
      formTitle.innerHTML = e.currentTarget.dataset.titletop;
      formTitleColor.innerHTML = e.currentTarget.dataset.titlebottom;
      modal.classList.add('active');
      if (e.currentTarget.classList.contains('cars')) {
        formCar.classList.add('active');
        document.querySelector('#carType').value = e.currentTarget.dataset.type;
      } else {
        formCalc.classList.add('active');
      }
      modal.setAttribute('aria-hidden', 'false');

      if (window.innerWidth > 1000) {
        body.classList.add('scrollLock');
        header.classList.add('scrollLock2');
        socialFixed.classList.add('social-modal');
      }
    })
  );
  document.querySelectorAll('[data-modals-close]').forEach((e) =>
    e.addEventListener('click', (e) => {
      modal.classList.remove('active');
      formCar.classList.remove('active');
      formCalc.classList.remove('active');
      modal.setAttribute('aria-hidden', 'true');
      modalContent.classList.remove('hide');
      contentThanks.classList.remove('active');
      submitsAll.forEach((e) => {
        e.form.reset();
      });
      isValidFormName = false;
      isValidFormTel = false;
      isValidFormEmail = false;
      isValidFormName2 = false;
      isValidFormTel2 = false;
      isValidFormEmail2 = false;
      if (window.innerWidth > 1000) {
        body.classList.remove('scrollLock');
        header.classList.remove('scrollLock2');
        socialFixed.classList.remove('social-modal');
      }
    })
  );
  document.querySelector('.myModal').addEventListener('click', (e) => {
    if (!e.target.closest('.myModal__content')) {
      modal.classList.remove('active');
      formCar.classList.remove('active');
      formCalc.classList.remove('active');
      modal.setAttribute('aria-hidden', 'true');
      modalContent.classList.remove('hide');
      contentThanks.classList.remove('active');
      submitsAll.forEach((e) => {
        e.form.reset();
      });
      isValidFormName = false;
      isValidFormTel = false;
      isValidFormEmail = false;
      isValidFormName2 = false;
      isValidFormTel2 = false;
      isValidFormEmail2 = false;
      if (window.innerWidth > 1000) {
        header.classList.remove('scrollLock2');
        body.classList.remove('scrollLock');
        socialFixed.classList.remove('social-modal');
      }
    }
  });

  //validate

  const inputName = document.querySelector('#inputName');
  const inputTel = document.querySelector('#inputTel');
  const inputEmail = document.querySelector('#inputEmail');
  const inputBtn = document.querySelector('.modal-form-btn');
  const inputBtnLeft = document.querySelector('.modal-form-btn-left');
  const inputBtnCalc = document.querySelector('.modal-form-btn-calc');
  const phoneValue1 = document.querySelector('#phone1');
  const phoneValue2 = document.querySelector('#phone2');

  const nameRegex = /^[A-Za-zА-Яа-яЁё\- ]+$/;
  const phoneRegex =
    /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  let isValidFormName = false;
  let isValidFormTel = false;
  let isValidFormEmail = false;
  const valid = () => {
    phoneValue1.value = updatePhoneNumber2();

    if (isValidFormName && isValidFormTel && isValidFormEmail) {
      inputBtn.removeAttribute('disabled');
      inputBtn.classList.remove('disabled-btn');
      inputBtnLeft.classList.remove('disabled');
      inputBtnCalc.classList.remove('disabled');
    } else {
      inputBtn.setAttribute('disabled', 'true');
      inputBtn.classList.add('disabled-btn');
      inputBtnLeft.classList.add('disabled');
      inputBtnCalc.classList.add('disabled');
    }
  };

  inputName.addEventListener('input', () => {
    if (nameRegex.test(inputName.value)) {
      isValidFormName = true;
      inputName.classList.remove('red-border');
      inputName.classList.add('green-border');
    } else {
      isValidFormName = false;
      inputName.classList.remove('green-border');
      inputName.classList.add('red-border');
    }
    valid();
  });
  inputTel.addEventListener('input', () => {
    inputTel.value = inputTel.value.replace(/[^\d]/g, '');
    if (phoneRegex.test(updatePhoneNumber2())) {
      isValidFormTel = true;
      inputTel.classList.remove('red-border');
      inputTel.classList.add('green-border');
    } else {
      isValidFormTel = false;
      inputTel.classList.remove('green-border');
      inputTel.classList.add('red-border');
    }
    valid();
  });

  inputEmail.addEventListener('input', () => {
    if (emailRegex.test(inputEmail.value)) {
      inputEmail.classList.remove('red-border');
      inputEmail.classList.add('green-border');
      isValidFormEmail = true;
    } else {
      isValidFormEmail = false;
      inputEmail.classList.remove('green-border');
      inputEmail.classList.add('red-border');
    }
    valid();
  });

  //validate2

  const inputName2 = document.querySelector('#inputName2');
  const inputTel2 = document.querySelector('#inputTel2');
  const inputEmail2 = document.querySelector('#inputEmail2');
  const inputBtn2 = document.querySelector('#modal-form-btn2');
  const inputBtnLeft2 = document.querySelector('#modal-form-btn-left2');
  const inputBtnCalc2 = document.querySelector('#modal-form-btn-calc2');

  let isValidFormName2 = false;
  let isValidFormTel2 = false;
  let isValidFormEmail2 = false;
  const valid2 = () => {
    phoneValue2.value = updatePhoneNumber3();

    if (isValidFormName2 && isValidFormTel2 && isValidFormEmail2) {
      inputBtn2.removeAttribute('disabled');
      inputBtn2.classList.remove('disabled-btn');
      inputBtnLeft2.classList.remove('disabled');
      inputBtnCalc2.classList.remove('disabled');
    } else {
      inputBtn2.setAttribute('disabled', 'true');

      inputBtn2.classList.add('disabled-btn');
      inputBtnLeft2.classList.add('disabled');
      inputBtnCalc2.classList.add('disabled');
    }
  };

  inputName2.addEventListener('input', () => {
    if (nameRegex.test(inputName2.value)) {
      isValidFormName2 = true;
      inputName2.classList.remove('red-border');
      inputName2.classList.add('green-border');
    } else {
      isValidFormName2 = false;
      inputName2.classList.remove('green-border');
      inputName2.classList.add('red-border');
    }
    valid2();
  });
  inputTel2.addEventListener('input', () => {
    inputTel2.value = inputTel2.value.replace(/[^\d]/g, '');
    if (phoneRegex.test(updatePhoneNumber3())) {
      isValidFormTel2 = true;
      inputTel2.classList.remove('red-border');
      inputTel2.classList.add('green-border');
    } else {
      isValidFormTel2 = false;
      inputTel2.classList.remove('green-border');
      inputTel2.classList.add('red-border');
    }
    valid2();
  });

  inputEmail2.addEventListener('input', () => {
    if (emailRegex.test(inputEmail2.value)) {
      isValidFormEmail2 = true;
      inputEmail2.classList.remove('red-border');
      inputEmail2.classList.add('green-border');
    } else {
      isValidFormEmail2 = false;
      inputEmail2.classList.remove('green-border');
      inputEmail2.classList.add('red-border');
    }
    valid2();
  });

  //headerHide

  let lastScroll = 0;
  let defaultOffset = 200;

  const scrollPosition = () =>
    window.scrollY || document.documentElement.scrollTop;

  const headerHide = () => {
    const containHide = header.classList.contains('hide');
    const burgerMenu = document.querySelector('.header__burger-menu');
    burgerMenu.classList.contains('open');
    if (
      scrollPosition() > lastScroll &&
      !containHide &&
      scrollPosition() > defaultOffset
    ) {
      burgerMenu.classList.contains('open') ? '' : header.classList.add('hide');
    } else if (scrollPosition() < lastScroll && containHide) {
      header.classList.remove('hide');
    }
    lastScroll = scrollPosition();
  };

  window.addEventListener('scroll', () => {
    handleScroll();
    headerHide();
  });

  //animation truck
  gsap.registerPlugin(ScrollTrigger);

  const countEl = document.querySelector('.section3__img-loading-left-num');
  const countDrops = document.querySelector('.section3__img-loading-right img');

  const anim = gsap.timeline();

  const count = (progress) => {
    const countValue = Math.ceil(progress * 180);
    const editValue = countValue <= 100 ? countValue : 100;
    countEl.innerHTML = editValue;
    const down = countDrops.getAttribute('data-down');
    const drop = countDrops.getAttribute('data-drop');
    countDrops.setAttribute('src', editValue % 2 ? down : drop);
  };

  anim
    .to('.section3__animation-wpapper', { duration: 3 })
    .add('two', 2)
    .to(
      '.section3__img-main',
      {
        x: '-100%',
        opacity: 0,
        duration: 2,
        ease: 'sine.in',
      },
      'two'
    )
    .to(
      '.section3__img-top',
      {
        y: '-100%',
        opacity: 0,
        duration: 2,
      },
      'two'
    )
    .add('after', 4)

    .to(
      '.section3__img-loading',
      {
        y: '-425%',
        duration: 2,
      },
      'after'
    )
    .to(
      '.after-anim',
      {
        y: '-35%',
        duration: 2,
      },
      'after'
    );

  ScrollTrigger.create({
    animation: anim,
    trigger: '.section3__animation-wrapper',
    start: window.innerWidth > 1000 ? 'bottom bottom' : 'center center',

    end: 'bottom top',
    scrub: 5,
    pin: true,
    onUpdate: (self) => {
      count(self.progress);
    },
  });

  //thanks alert
  const alertTriggers = document.querySelectorAll('form');
  const modalContent = document.querySelector('.myModal__content');
  const contentThanks = document.querySelector('.myModal__content-thanks');

  alertTriggers.forEach((e) =>
    e.addEventListener('submit', () => {
      inputBtn.classList.add('disabled-btn');
      inputBtn2.classList.add('disabled-btn');

      inputBtnLeft.classList.add('disabled');
      inputBtnCalc.classList.add('disabled');
      inputBtnLeft2.classList.add('disabled');
      inputBtnCalc2.classList.add('disabled');
      formCar.classList.remove('active');
      formCalc.classList.remove('active');
      modal.setAttribute('aria-hidden', 'true');

      if (window.innerWidth > 1000) {
        body.classList.remove('scrollLock');
        header.classList.remove('scrollLock2');
        socialFixed.classList.remove('social-modal');
      }
      modalContent.classList.add('hide');
      contentThanks.classList.add('active');
    })
  );

  //int tel input

  const iti2 = window.intlTelInput(inputTel, {
    initialCountry: 'ua',
    separateDialCode: true,
    nationalMode: false,
    utilsScript:
      'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
  });
  function updatePhoneNumber2() {
    const phoneNumberWithDialCode = iti2.getNumber();
    return phoneNumberWithDialCode;
  }

  function isValidNumber2() {
    const isValidNumber2 = iti2.isValidNumber();
    return isValidNumber2;
  }

  const iti3 = window.intlTelInput(inputTel2, {
    initialCountry: 'ua',
    separateDialCode: true,
    nationalMode: false,
    utilsScript:
      'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
  });

  function updatePhoneNumber3() {
    const phoneNumberWithDialCode = iti3.getNumber();
    return phoneNumberWithDialCode;
  }

  function isValidNumber3() {
    const isValidNumber3 = iti3.isValidNumber();
    return isValidNumber3;
  }
});
